// Truy vấn lịch hẹn (crm-service, gateway chặn theo module schedule).
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { http, qk } from '@/shared/api';
import { syncServerTime } from '@/shared/lib';
import type { TaskCounts, TaskFilters, TaskList, TaskView } from './model';

/**
 * Danh sách theo tab (server nhóm theo ngày giờ Việt Nam — T9). Đổi người xem giữ dữ liệu cũ tới khi có mới; đổi tab
 * thì không (tránh hiện danh sách tab khác dưới tiêu đề tab mới).
 */
export const useTasks = (f: TaskFilters, o: { refetchInterval?: number; enabled?: boolean } = {}) =>
  useQuery({
    queryKey: qk.tasks.list(f),
    queryFn: async ({ signal }) => {
      const r = await http.get<TaskList>('/crm/tasks', { query: { tab: f.tab, staffId: f.staffId, weekOf: f.weekOf, pageSize: 500 }, signal });
      syncServerTime(r.serverTime);
      return r;
    },
    placeholderData: (prev, prevQuery) => ((prevQuery?.queryKey[2] as TaskFilters | undefined)?.tab === f.tab ? keepPreviousData(prev) : undefined),
    refetchInterval: o.refetchInterval,
    enabled: o.enabled ?? true,
  });

/** Truy vấn số việc (dùng chung cho hook và nơi cần đọc một lần qua queryClient.fetchQuery). */
export const taskCountsQuery = (staffId: string) => ({
  queryKey: qk.tasks.counts(staffId),
  queryFn: ({ signal }: { signal?: AbortSignal }) => http.get<TaskCounts>('/crm/tasks/counts', { query: { staffId: staffId || undefined }, signal }),
});

/** Số việc chưa xong theo nhóm Hôm nay / Quá hạn / Sắp tới; staffId '' = Cả đội. */
export const useTaskCounts = (staffId: string, enabled = true) =>
  useQuery({
    ...taskCountsQuery(staffId),
    placeholderData: keepPreviousData,
    enabled,
  });

/** Chi tiết (kèm version cho If-Match, người tạo). */
export const useTask = (id: string | null) =>
  useQuery({
    queryKey: qk.tasks.detail(id ?? ''),
    queryFn: ({ signal }) => http.get<TaskView>(`/crm/tasks/${id}`, { signal }),
    enabled: !!id,
  });
